// extracted by mini-css-extract-plugin
export default {"buttonContainer":"ChangeKindSelector_buttonContainer__I6vGF","active":"ChangeKindSelector_active__Kw521"};